import styled from "styled-components"

export default styled.div`
 img {
   width: 20px;
   height: 20px;
 }
`
